import { fetcher } from "../api/fetcher";
import { roomState } from "../states/room";

export function endMeeting() {
  fetcher
    .post({
      path: "/active-room/end-call",
      payload: {
        room_id: roomState.id,
      },
    })
    .catch(() => {
    });
}
